import {
  CUSTOM_FIELD_SUBJECT_TYPES,
  CUSTOM_FIELD_TYPES,
  CustomFieldParams,
} from "@/types/customFieldTypes";
import { isEmpty } from "../../helpers/utils";
import { File } from "../file";

export class CustomField {
  static readonly MAX_ID_LENGTH: number = 100;

  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  subjectId: string;
  parentId: string;
  subjectType: CUSTOM_FIELD_SUBJECT_TYPES;
  readonly fieldType: CUSTOM_FIELD_TYPES;
  defaultValue: string | number | boolean | undefined;
  customValue: string | number | boolean | undefined;
  isSelected?: boolean;
  position: number;
  file?: File;
  sourceId: string;
  isRequired: boolean;
  isCustomChoice: boolean;
  title: string;
  propelOrgId: string;

  constructor(data: CustomFieldParams) {
    this.id = data.id;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.subjectId = data.subjectId;
    this.parentId = this.subjectId;
    this.subjectType = data.subjectType;
    this.fieldType = data.fieldType;
    this.defaultValue = data.defaultValue;
    this.customValue = data.customValue;
    this.isSelected = data.isSelected ?? false;
    this.position = data.position || 0;
    this.sourceId = data.sourceId || '';
    this.isRequired = data.isRequired || false;
    this.isCustomChoice = data.isCustomChoice || false;
    this.title = data.title || '';
    this.propelOrgId = data.propelOrgId || '';
  }

  isString() {
    return this.fieldType === CUSTOM_FIELD_TYPES.String;
  }

  getValue() {
    if (this.customValue != null) return this.customValue;
    return this.defaultValue;
  }

  formatFromRead() {}

  asString() {
    const value = this.getValue();
    if (value == null) return "";
    return value.toString();
  }

  // this should only be invoked if a custom field has an unknown type - therefore it is not valid
  hasValidDefaultInput() {
    return false;
  }

  hasValidCustomInput() {
    return false;
  }

  getUpdatedAt() {
    return this.updatedAt;
  }

  valueForPywertrain() {
    return this.asString();
  }

  isEmpty() {
    return isEmpty(this.getValue());
  }

  // Choices can carry a display label (`title`) that differs from the value the
  // procedure consumes - e.g. a `10x` probe setting whose value is `0.1`.
  getLabel() {
    return this.title || this.asString();
  }

  hasDistinctLabel() {
    return !!this.title && this.title !== this.asString();
  }
}
